import React from "react";
import { Info } from "lucide-react";
import { useLanguage } from "../i18n";

export default function LanguageSupportNotice() {
  const { t } = useLanguage();

  return (
    <div className="mb-6 rounded-2xl border border-[#C9A227]/20 bg-[#fff8ec] px-4 py-4 text-sm text-gray-700">
      <div className="flex items-start gap-3">
        <Info className="w-5 h-5 mt-0.5 text-[#722F37] flex-shrink-0" />
        <div>
          <p className="font-medium text-[#722F37]">{t("notices.title")}</p>
          <p className="mt-1">{t("notices.body")}</p>
        </div>
      </div>
    </div>
  );
}
